import React, { useEffect, useRef, useState } from 'react';

const ADSBYGOOGLE_SRC =
  'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4910046262930409';

const FooterAd: React.FC = () => {
  const insRef = useRef<HTMLModElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [slotHeight, setSlotHeight] = useState<number>(50);

  // Keep wrapper height enforced via inline style to defeat external overrides
  useEffect(() => {
    const mq = window.matchMedia('(min-width: 768px)');
    const apply = () => setSlotHeight(mq.matches ? 90 : 50);
    apply();
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  useEffect(() => {
    // Inject AdSense script once if not present
    const existing = document.querySelector(
      `script[src^="${ADSBYGOOGLE_SRC}"]`
    ) as HTMLScriptElement | null;
    if (!existing && false) {
      const s = document.createElement('script');
      s.async = true;
      s.src = ADSBYGOOGLE_SRC;
      s.crossOrigin = 'anonymous';
      document.head.appendChild(s);
      s.onload = () => {
        try {
          // @ts-ignore
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch {}
      };
    } else {
      try {
        // @ts-ignore
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch {}
    }
  }, []);

  // Enforce container caps even if mutated by third-party
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const applyLock = () => {
      el.style.setProperty('height', `${slotHeight}px`, 'important');
      el.style.setProperty('max-height', `${slotHeight}px`, 'important');
      el.style.setProperty('min-height', `${slotHeight}px`, 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    };
    applyLock();

    const observer = new MutationObserver(() => applyLock());
    observer.observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
    return () => observer.disconnect();
  }, [slotHeight]);

  return (
    <div
      ref={containerRef}
      className="footer-ad-container fixed bottom-0 left-0 w-full z-40 bg-[#090312] overflow-hidden hidden md:block"
      style={{ height: `${slotHeight}px`, maxHeight: `${slotHeight}px`, minHeight: `${slotHeight}px` }}
    >
      <div className="h-full w-full flex items-center">
       
      </div>
    </div>
  );
};

export default FooterAd;
